const selfcareMethods = {
  validateUserBeforeResetParentalCode: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/ValidateUserBeforeResetParentalCode',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['id', 'card', 'externalAssetId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  doResetParentalCode: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/DoResetParentalCode',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['externalAssetId', 'pinCode'],

    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  customerInit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'General/CustomerInit',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 60000,
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  doCallBackToAuthorized: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'General/CallBack',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['IdNumber', 'PhoneNumber', 'SubjectCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  sendReportToCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SendReportToContact',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['BlockId', 'OrgId', 'MailAddress', 'FilterList', 'ReportName'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getReportsForCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetBusinessReportsForContact',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  transferBussinessCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/TransferBussinessCustomer',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  blockTransferBusinessCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/BlockNiud',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['ban', 'subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createOrgSimOrder: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/CreateOrgSimOrder',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },

  getProductsAndServices: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ProductsAndServices',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetBanPsidInfo: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/GetBanPsidInfo',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getCustomerActiveCellularList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ProductsAndServices/getCustomerActiveCellularList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCustomerCellularList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ProductsAndServices/getCustomerCellularList',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getTvCustomerList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ProductsAndServices/getCustomerTvList', //'TvUserAction/getTvCustomerList',
    timeout: 37000,
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getConsumersInDebt: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['idNumber', 'accountType', 'orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrgPaymentMethodList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/getOrgPaymentMethodList',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['IdNumber', 'AccountType', 'IsPrivateUserFlow'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  AddPrivateCallback: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/PrivateCallBack',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['IdNumber', 'phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  updatePaymentMethod: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/putPaymentMethod',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'AccountList',
      'BanOrPsid',
      'CCToken',
      'CardYear',
      'CardMonth',
      'CardCvv',
      'CreditCardType',
      'CCFourLastNumbers',
      'PaymentOwnerFirstName',
      'PaymentOwnerLastName',
      'ConsumerId',
      'EMail',
      'IdNumber',
      'OrgType',
      'PaymentMethodType',
      'PaymentType',
      'PhoneNumber',
      'BankAccountFileGuid',
      'AuthNo',
      'IsBusiness',
      'PrivateUserIdNumber',
      'PaymentEntityId',
      'PaymentEntityFirstName',
      'PaymentEntityLastName',
      'PaymentEntityCity',
      'PaymentEntityStreet',
      'PaymentEntityZip',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getBankObligationSignatureFile: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/GetBankObligationSignatureFile',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  creditCardPay: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/CreditCardPay',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'Account',
      'IdNumber',
      'ConsumerId',
      'CreditCardType',
      'OrgType',
      'CCToken',
      'CardCvv',
      'CardYear',
      'CardMonth',
      'Amount',
      'AuthNo',
      'PaymentNo',
      'PhoneNumber',
      'EMail',
      'OrgId',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  submitBankPaymentMethod: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/SubmitBankPaymentMethod',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  submitCCPaymentMethod: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/SubmitCCPaymentMethod',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  debtPaymentHandleContactUs: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/OpenFollowUp',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Account', 'OrgId', 'OrgType', 'FollowUpType', 'IdNumber', 'PhoneNumber', 'Email'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getContactCompanyList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/getContactCompanyList',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetOrganizationFamilyData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetOrganizationFamilyData',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  AssignBenefitsToOrgFamilyMember: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/AssignBenefitsToOrgFamilyMember',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  SendBenefitsSmsToOrgFamilyMember: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SendBenefitsSmsToOrgFamilyMember',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phone'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrgFamilyBenefitsAllocations: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetOrgFamilyBenefitsAllocations',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },

  validateAccountToIMEIService: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/ValidateSelectedAccountToIMEIService',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrgId', 'StartPoint', 'SelectedNumber', 'SelectedIMEI', 'IsPrivate', 'isFromPrivateSelfCare'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  submitSelectedEMEIConfirmation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/SubmitSelectedEMEIConfirmation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrgId', 'StartPoint', 'SelectedNumber', 'SelectedIMEI', 'IsPrivate', 'IsFromPrivateSelfCare'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  IMEIDeviceRepairGeneralData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/GetGeneralData',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  createNotificationImeiRepairDevice: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/CreateNotification',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'SelectedNumber',
      'SelectedIMEI',
      'CauseList',
      'LockCode',
      'AlternatePhone',
      'ClearContent',
      'NotificationType',
      'IsPrivate',
      'IsFromPrivateSelfCare',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getPickUpDeliveryTimeSlots: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/GetIMEIPickupDeliverySlots',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['City', 'Street', 'HomeNum', 'DispatchType', 'RefOrder'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createPickupDeliveryNotification: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/CreatePickupDeliveryNotification',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'SelectedNumber',
      'Street',
      'City',
      'HouseNum',
      'ApartmentNum',
      'ContactPersonName',
      'ContactPersonLastName',
      'ContactPersonPhone',
      'Notes',
      'RefOrder',
      'PickUpRefOrder',
      'DispLidRsn',
      'DlvDate',
      'ShipCond',
      'NotificationType',
      'PickLocation',
      'LockCode',
      'AlternatePhone',
      'ClearContent',
      'IsPrivate',
      'IsFromPrivateSelfCare',
      'SelectedIMEI',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  isLockedValidationImeiDeviceRepair: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/IsLockedValidation',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['imei'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getPickUpTimeSlots: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IMEIDeviceRepair/GetPickUpTimeSlots',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getBussinessInvoices: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/searchInvoice',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getBansForOrganization: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetBansForOrganization',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrgBansTransferAccount: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetOrgBansTransferAccount',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  fetchExistingOwnershipTransferRequests: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/OwnershipTransferDashboardData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  ownershipTransferCustomerValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/OwnershipTransferCustomerValidation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrgId', 'ActionType', 'SubscriberPhoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ownershipTransferMLCustomerValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/OwnershipTransferMLCustomerValidation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrgId', 'ActionType', 'SubscriberPhoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  addOwnershipTransferRequest: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/AddOwnershipTransferRequest',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  uploadFileOwnershipTransferRequest: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/UploadOwnershipTransferUsersList',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  submitOwnershipTransferCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/SubmitOwnershipTransferCustomer',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getOwnershipTransferSignatureFile: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/GetOwnershipTransferSignatureFile',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  updateOwnershipTransferRequest: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/UpdateOwnershipTransferRequest',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  ValidateOwnershipTransferDashboardStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/ValidateOwnershipTransferDashboardStatus',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  UploadOwnershipTransferUsersList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/UploadOwnershipTransferUsersList',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  submitTransferServiceValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/ProductTransferValidation',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createWorkOrderOwnershipTransfer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/CreateWorkOrderOwnershipTransfer',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createOwnershipTransferSellerRequest: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/CreateOwnershipTransferSellerRequest',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  validateOwnershipTransferAccess: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/ValidateMLServiceAccess',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  submitPrivateOwnershipTransfer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/SubmitOwnershipTransfer',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  idNumberAndCCValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OwnershipTransfer/IdNumberAndCCValidation',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['requestId'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getBussinessInvoicesPdf: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/InvoicePdf',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['companyId', 'invoiceOrigin', 'invoiceNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  disconnect: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disconnect',
    httpMethod: 'get',
    isJsonRequest: true,
    timeout: 40000,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  disconnectFinal: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disconnect',
    httpMethod: 'put',
    isJsonRequest: true,
    timeout: 60000,
    getArgumentName: [
      'ProductId',
      'Round',
      'Lfdat',
      'WaitTo',
      'WaitFrom',
      'PickLocation',
      'DisconnectReasons',
      'DisconnectReference',
      'DisconnectDate',
      'HasDelivery',
      'ShippingCost',
      'Street',
      'City',
      'HouseNum',
      'AptNum',
      'PhoneNumber',
      'Email',
      'NotesForDelivery',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  deliveryTimeSlots: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Disconnect/DeliveryTimeSlots',
    httpMethod: 'get',
    isJsonRequest: false,
    timeout: 60000,
    getArgumentName: ['ProductId', 'City', 'Street', 'HouseNum'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getUpdateCellularPackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Disconnect/changePricePlan',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['ProductId', 'ProgramCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  equipmentForProduct: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disconnect/equipmentForProduct',
    httpMethod: 'get',
    isJsonRequest: false,
    timeout: 60000,
    getArgumentName: ['ProductId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  disconnectAllowedForProduct: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disconnect/disconnectAllowedForProduct',
    httpMethod: 'get',
    isJsonRequest: false,
    timeout: 60000,
    getArgumentName: ['ProductId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  changePricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disconnect/disconnectAllowedForProduct/productId/programCode',
    httpMethod: 'put',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCurrentCellularPricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetCurrentCellularPlan',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['SubscriberNo', 'Ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getPersonalizedPricePlans: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetPersonalizedPricePlans',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['Ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  fetchPricePlanMetadata: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetPricePlanMetadata',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['offerId', 'ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetProductsById: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetProductsById',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['IdNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  UpdatePricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/UpdatePricePlan',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getFuturePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetFuturePlan',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['SubscriberNo', 'Ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateAndSendMagicLink: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/ValidateAndSendMagicLink',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'Link'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkIfExistsInFather: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/CheckIfExistsInFather',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['SubscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getRegisteredNumberListMabal: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/GetRegisteredNumberListMabal',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrdersList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'numberPortability/getOrdersList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNumber', 'ticketId', 'verificationCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  requestActivate: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'numberPortability/requestActivate',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  CheckNiudCodeRequirement: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'numberPortability/CheckNiudCodeRequirement',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['captchaToken', 'phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSelectedSubscriberDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/GetSelectedSubscriberDetails',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['SubscriberNo', 'Ban'],
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendRequestChangePricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePricePlan/ChangePricePlan',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'SendingMethod',
      'ContactDestination',
      'OtpPhoneNumber',
      'Ban',
      'SubscribersData',
      'CollaborationApproval',
      'AgreeReceiveReceiptToMail',
      'isImmediateTransitionPlan',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkForVolteService: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Selfcare/CheckAndInstallVolteService',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkImeiForVolte: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Selfcare/checkImeiForVolte',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['Imei'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  sendBussinessInvoicesPdf: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/sendInvoicePdf',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetCustomerDetailsForBusinessContactManager: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetCustomerDetailsForBusinessContactManager',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'FormType', 'LockUnlockNp'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCcrReport: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetCcrReport',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'EMail', 'Dates'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ChangeSim: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/ChangeSim',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'PhoneNumber', 'NewSimNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ValidateSim: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/ValidateSim',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['simNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  niudNumberValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/NiudNumberValidation',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ChangeClientName: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/UpdateBusinessCustomerName',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'NewFirstName', 'NewLastName', 'IsThirdPartySign', 'UpdatePrivateSubscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetDataUsage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetSurfingUseDetailsForBusiness',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'isPrivate', 'blockId', 'isRefresh', 'isBusiness'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  AddOrRemoveImei: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/AddOrRemoveImei',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'Action', 'SelectedImei', 'IsSecondRound'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateSelectedAccount: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/ValidateSelectedAccount',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'FirstName', 'LastName'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SuspendOrActivateBusinessAccount: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SuspendOrActivateBusinessAccount',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SelectedNumber', 'Action', 'Reason', 'CanDoAction', 'MsgCode', 'Msg', 'FormType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  AddSurfingPackageForBusiness: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/AddSurfingPackageForBusiness',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['OrgId', 'SubscriberNo', 'SocBlockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  trackerClearCache: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/ClearCache',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['type'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSurfingDataUsageDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SurfingUseDetails/GetSurfingUseDetails',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['isPrivate', 'blockId', 'isRefresh'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  surfingUseAddPackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SurfingUseDetails/AddPackage',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'Soc'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  isCustomerAllowedForSelfCreatedTechnicianVisit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/IsCustomerAllowedForSelfCreatedTechnicianVisit',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SetSlotsStandAlone: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/SetSlotsStandAlone',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'IdNumber',
      'ServiceId',
      'Date',
      'StartTime',
      'EndTime',
      'CityCode',
      'StreetCode',
      'StreetName',
      'MatHouseNum',
      'MatFlatNum',
      'DeptId',
      'DescrTask',
      'TashtitType',
      'Enter',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getDBBitStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/GetDBBitStatus',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createBitRequest: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/CreateBitRequest',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Ban', 'PaymentSubject', 'PaymentAmount', 'CustomerEmail', 'BillByEmail', 'Device', 'TotalAmount'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  bitStatusValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/BitStatusValidation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Ban', 'ExternalSystemReference'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCurrentPaymentStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/GetCurrentPaymentStatus',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Ban', 'ExternalSystemReference'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getBanDebtsPrivate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/Debt',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCustomerPaymentsData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/GetCustomerPaymentsData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  creditCardPayDebtPrivate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/CreditCardPayDebtPrivate',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'Account',
      'IdNumber',
      'ConsumerId',
      'CreditCardType',
      'OrgType',
      'CCToken',
      'CardCvv',
      'CardYear',
      'CardMonth',
      'Amount',
      'AuthNo',
      'PaymentNo',
      'PhoneNumber',
      'EMail',
      'BillByEmail',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  debtPayByCreditCard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/DebtPayByCreditCard',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  updateMailingMethod: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/UpdateMailingMethod',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['newMethod', 'mailingDest', 'ban', 'isPrimaryEmail', 'CollaborationApproval'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  PaymentMethodValidation: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,

    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Payment/PaymentMethodValidation',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Payment/PaymentMethodValidationAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkIsKosherOrAflaloNumber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'NumberValidation/CheckIsKosherOrAflaloNumber',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['number'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getTechnicianVisitData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/GetCustomerVisitInfoList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getTechnicianTimeSlots: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/GetTechnicianTimeSlots',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  updateTechnicianTimeSlot: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/UpdateTechnicianTimeSlot',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkIsVisitTimeSlotCancelable: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/CheckIsVisitTimeSlotCancelable',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrderId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  cancelTechnicianTimeSlot: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/CancelTechnicianTimeSlot',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrderId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkUserStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'GenericVAS/CheckUserStatus',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId,', 'subscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  saveGenericVAS: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'GenericVAS/SaveGenericVAS',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['captchaToken', 'blockId', 'subscriberNo', 'socType', 'email', 'socName', 'isServiceAccessFormChecked'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendEmailHaveEsim: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'GenericVAS/SendEmailHaveEsim',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['captchaToken', 'blockId', 'subscriberNo', 'socType', 'email'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getContactAndAccountDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'UpdateCustomerDetails/GetContactAndAccountDetails',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  updateContactAndAccountDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'UpdateCustomerDetails/UpdateContactAndAccountDetails',
    httpMethod: 'post',
    timeout: 40000,
    isJsonRequest: true,
    getArgumentName: ['data'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  updateContactAndAccountDetailsPopUpOnly: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'UpdateCustomerDetails/UpdateContactAndAccountDetailsPopUpOnly',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getContactAndAccountDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'UpdateCustomerDetails/GetContactAndAccountDetails',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  selfCareData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/SelfCareData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  OnboardingData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/GetSelfcareDataOnboarding',
    httpMethod: 'Get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 60000,
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  invoiceData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/InvoiceData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  trackerData: {
    timeout: 120000,
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/TrackerData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['banPsid'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getInvoiceBillUrl: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/GetInvoiceBillUrl',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  benefitData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/BenefitData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createStandAloneSale: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/CreateStandAloneSale',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['data'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  debitAndRefund: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/DebitAndRefund',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrganizationFamilyPackagesData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/GetOrganizationFamilyPackagesData',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getOrganizationData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/GetOrganizationData',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['subscriberOrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  CheckForCustomerFeature: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/CheckForCustomerFeature',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['OrgId', 'PhoneNumber', 'SwitchCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  uploadFile: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/UploadFile',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['FileType', 'FileContentBase64', 'capchaValue', 'action', 'mail', 'FileName', 'bussinessNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  UpdateOrCancelBusinessDelivery: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/UpdateOrCancelBusinessDelivery',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'Ban',
      'DispatchOrder',
      'NoteOrder',
      'deliveryRequestAction',
      'NewCity',
      'NewStreet',
      'NewHome',
      'NewApartment',
      'NewDeliveryDate',
      'NewRoundFrom',
      'NewRoundTo',
      'UserName',
      'PhoneForDelivery',
      'PhoneForDelivery2',
      'PickLocation',
      'Round',
      'Comments',
      'IsBusiness',
      'SubscriberNoOrIMEI',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  /*
    getSubscribers: {
      online: true,
      requiredLogin: true,
      apiSuffixName: 'Subscribers/GetSubscribers',
      httpMethod: 'get',
      isJsonRequest: true,
      getArgumentName: ['saleType'],
      headers: {
        'Content-Type': 'application/json',
      },
      error: [{code: '009', description: 'ארעה שגיאה'}],
    },
    */

  CollaborationUpdate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ThirdParty/CollaborationUpdate',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ThirdPartyUpdate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ThirdParty/ThirdPartyUpdate',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  UploadOrgUsersList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/UploadOrgUsersList',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  GetOrgUserList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/GetOrgUserList',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  FindUserByNameOrByPhone: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/FindUserByNameOrByPhone',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetUpdatablePermissionsByUser: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/GetUpdatablePermissionsByUser',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  DeleteOrgUser: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/DeleteOrgantationUser',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SendOrgPortalLinkToUser: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/SendOrgPortalLinkToUser',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetOrgUserDetails: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'OrganizationPortal/GetOrgUserDetails',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['phoneNumber', 'userId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  UpdateOrgUserDetails: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'OrganizationPortal/UpdateOrgUserDetails',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  UpdateOrgUserByContact: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/UpdateOrgUserByContact',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  UpdateOrgUserStatus: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'OrganizationPortal/UpdateOrgUserStatus',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  CreateSplitSignatureFile: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'OrganizationPortal/CreateSplitSignatureFile',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  CheckSplitFileSignature: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'OrganizationPortal/CheckSplitFileSignature',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['fileGuid'],
    enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  CheckServiceAndGetSubscribers: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'CellularDataOnOff/CheckServiceAndGetSubscribers',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 60000,
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SimReplacementInit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/SimReplacementInit',
    httpMethod: 'Get',
    isJsonRequest: false,
    getArgumentName: ['blockId', 'subscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  CellularDataOnOffInit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'CellularDataOnOff/init',
    httpMethod: 'Get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ToggleData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'CellularDataOnOff/ToggleData',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'socId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  CheckSimAvailability: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/SimReplacementCheck',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['simNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ReplaceSim: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SelfCare/SimReplacementSubmit',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['oldSim', 'newSim', 'newSimItemId', 'userBan', 'userPhoneNumber', 'userIdType', 'userIdNumber', 'todayDate'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  CheckEsimClientStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/CheckEsimClientStatus',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['chosenOrgNumber', 'userPhoneNumber', 'privateCompanyList'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetRentSuspensionReasons: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetRentSuspensionReasons',
    httpMethod: 'Get',
    isJsonRequest: true,
    getArgumentName: ['orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SendEmailRetriveQr: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SendEmailRetriveQr',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['clientName', 'scopeName', 'isDynamic', 'sendSms', 'sendEmail', 'parameters'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetQrCodeOrderInfo: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetQrCodeOrderInfo',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'contactOrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  SendQrCodeViaMagicLink: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SendQrCodeViaMagicLink',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'otpPhone', 'salesOrder'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getEsimPriceIfPreChecksPass: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetEsimPriceIfPreChecksPass',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'upgKey', 'upgKeyTheftOrLoss', 'contactOrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  isSubscriberEligibleForEsimUpgrade: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/IsSubscriberEligibleForEsimUpgrade',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendOrderForEsimUpgrade: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/SendOrderForEsimUpgrade',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'otpPhone', 'dispRsn', 'upgCourse', 'productId', 'package', 'combSeq'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  activateNiud: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/ActivateNiud',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['idNumberType', 'idNumber', 'hostNumber', 'niudNumber', 'contactOrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkNiudStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/CheckNiudStatus',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['niudNumber', 'contactOrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetTinyParameters: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetTinyParameters',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['params'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetOrganizationPricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/GetOrganizationPricePlan',
    httpMethod: 'Post',
    isJsonRequest: true,
    getArgumentName: ['orgId', 'ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  needsToSignCollaboration: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ThirdParty/NeedsToSignCollaboration',
    httpMethod: 'Get',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  userUpgrade: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Selfcare/UserUpgrade',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  removeService: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Selfcare/ChangeService',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkIfEntityDetailsRetrieved: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Ban/CheckIfEntityDetailsRetrieved',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['SubscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  isAllowedToShowThirdPartyPopup: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ThirdParty/IsAllowedToShowPopup',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCouponHistory: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Coupons/GetCouponHistory',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCouponTerms: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Coupons/GetCouponTerms',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['couponType'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  startTroubleshootingWizard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TroubleshootingWizard/StartTroubleshootingWizard',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['subscriberNumber, process'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  internationalCallUnblocking: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TroubleshootingWizard/InternationalCallUnblocking',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  localCallsTroubleshootingWizard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TroubleshootingWizard/LocalCallsTroubleshootingWizard',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getAllBusinessWorkOrderTypes: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/GetAllBusinessWorkOrderTypes',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getBusinessWorkOrderForm: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/GetWorkOrderForm',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['fu_type', 'org_id'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getExtendedParamData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/GetExtendedParamData',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  CreateBusinessWorkOrder: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/CreateBusinessWorkOrder',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  closeBusinessWorkOrder: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/CloseBusinessWorkOrder',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getBusinessWorkOrderInfo: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/GetWorkOrderInfo',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['fu_number', 'fu_ban'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getBusinessWorkOrderExistingRequests: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/GetBusinessWorkOrderExistingRequests',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  ValidateBusinessSubscribers: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessWorkOrderSystem/ValidateBusinessSubscribers',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  submitChangePhoneNumberValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePhoneNumber/ChangePhoneNumberCustomerValidation',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getNumberTypePrice: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePhoneNumber/GetNumberTypePrice',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getNumbersByType: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePhoneNumber/GetNumberListByType',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['type'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  isNumberAvailable: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePhoneNumber/isNumberAvailable',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  submitChangePhoneNumber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ChangePhoneNumber/SubmitChangePhoneNumber',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  LockUnlockNpStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BussinessCustomer/LockUnlockNpStatus',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Ban', 'SubscriberNumber', 'ActionType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
};

export default selfcareMethods;
